module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.24295db6.woff2";